import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import Year from '@/components/calendar/year/main';
import SchoolTheme from '@/domains/school/theme/main';
import SchoolClassList from '@/domains/school/class-list/main';

export default {
	name: 'LessonPlanningFilter',
	data: () => ({
		model: {
			onlyPending: false,
			currentClass: {},
			currentTheme: {},
		}
	}),
	computed: {
		...mapGetters([
			'currentYear',
			'getLoggedUser'
		]),
		formIsValid() {

			return this.currentYear && (
				this.model.currentTheme &&
				this.model.currentTheme.schoolThemeId &&
				this.model.currentClass &&
				this.model.currentClass.schoolClassId
			);

		}
	},
	components: {
		Year,
		SchoolTheme,
		SchoolClassList
	},
	methods: {
		...mapActions([
			'getSchoolClassLessonPlan',
			'clearSchoolClassLessonPlan'
		]),
		onSubmit() {

			if (this.formIsValid) {

				this.getSchoolClassLessonPlan({
					onlyPending: this.model.onlyPending,
					year: this.currentYear,
					theme: this.model.currentTheme.schoolThemeId,
					class: this.model.currentClass.schoolClassId,
					userId: this.getLoggedUser.id
				}).then((response) => EventBus.$emit('schoolClassLessonPlanFetched', response));

			}

		}
	},
	created() {

		EventBus.$on('themeSelected', (theme) => {

			this.model.currentTheme = theme;
			this.clearSchoolClassLessonPlan();

		});

		EventBus.$on('classChanged', (klass) => {

			this.model.currentClass = klass.data;

			if (klass.context !== 'LessonPlanningCopy') {
				this.clearSchoolClassLessonPlan();
			}

		});

		EventBus.$on('school-class-lesson-plan:copied', () => {
			this.onSubmit();
		});

	}
};



// WEBPACK FOOTER //
// ./sources/domains/lessons/planning-filter/index.js